import React, { FC, useState,useEffect } from 'react';
import { fetchRequestRepositorys} from '../../../redux/slices/RequestsSlice';
import { useAppDispatch, useAppSelector} from '../../../redux/store/store';
import { IRequests } from '../../../types/Requests';
import Spinner from '../../Spinner/Spinner';
import './RepositoryRequests.css'

interface ITableData {
id: string;
businessInformation: {
businessName: string;
businessCostCenter: string;
businessResponsible: string;
},
repositoryInformation: {
name: string;
description: string;
},
status: string;
organization: string;
requestedBy: string;
owner: string;
}

const ListRepositoryRequest = () => {
  interface ITableData {
    id: string;
    businessInformation: {
        businessName: string;
        businessCostCenter: string;
        businessResponsible: string;
    },
    repositoryInformation: {
        name: string;
        description: string;
    },
    status: string;
    organization: string;
    requestedBy: string;
    owner: string;
  }
const dispatch = useAppDispatch();
const [loading, setLoading] = useState(false);
useEffect(() => {
setLoading(true)
setTimeout(()=>{
dispatch(fetchRequestRepositorys())
setLoading(false)
}, 1000);
setLoading(true)
setTimeout(()=>{
setLoading(false)
}, 1000);
}, []);
const paging = useAppSelector(state => state.RequestsSlice.paging)
const result = useAppSelector(state => state.RequestsSlice.result);
console.log("este es el result:",result);

const data: ITableData[] = result.map((item: IRequests) => ({
id: item.id,
businessInformation: {
businessName: item.businessInformation.businessName,
businessCostCenter: item.businessInformation.businessCostCenter,
businessResponsible: item.businessInformation.businessResponsible
},
repositoryInformation: {
name: item.repositoryInformation.name,
description: item.repositoryInformation.description
},
status: item.status,
organization: item.organization,
requestedBy: item.requestedBy,
owner: item.owner
}));

// const handleOnBlur = () => {
//   if(!repositoryName){
//       dispatch(fetchRequestRepositorys());
//   }
// }

const GetRepositoryByName = (name: any) => {
  console.log('GetRepositoryByName:', name);
  dispatch(fetchRequestRepositorys(name));
}

return  loading ? <Spinner/>: (
   <div className="pds-dataTable pds-datatable-hoverable-rows">
  <div className="pds-dataTable-header">
    <p aria-hidden="true" className="pds-dataTable-title"></p>
    <div className="pds-searchInput pds-dataTable-smart-search" style={{maxWidth: 600, alignContent: 'left'}}>
      <input aria-label="Filter table data search bar" className="search inputSearch pds-input-small" type="search" placeholder="Buscar Repositorio" />
      <button type="submit" aria-label="Search" aria-disabled="true" />
    </div>
  </div>
  <div className="pds-dataTable-table-container pds-table-scrolling ">
  
    <table className="pds-table-container pds-table pds-table-bordered pds-table-hoverable-rows" id="pds-datatable-hoverable-rows-example" aria-live="polite">
      <caption className="sr-only">Title</caption>
      <thead>
        <tr>
        
          <th  className="sort pds-dataTable-table-header" scope="col" align='center'>Nombre del Repositorio</th>
          <th  className="sort pds-dataTable-table-header" scope="col" align='center'>Organizacion</th>
          <th  className="sort pds-dataTable-table-header" scope="col" align='center'>Responsable del Repositorio</th>
          <th  className="sort pds-dataTable-table-header" scope="col" align='center'>Nombre del Negocio</th>
          <th  className="sort pds-dataTable-table-header" scope="col" align='center'>Descripcion</th>
          <th className="sort pds-dataTable-table-header"  scope="col" colSpan={3}>Acciones</th>
       
         
          
        </tr>
      </thead>
      {data.map(item => (
     <tbody className="tbody">
    <tr className="trBody" key={item.id}>
      
      <td className="td">{item.repositoryInformation.name}</td>
      <td className="td">{item.organization}</td>
      <td className="td">{item.businessInformation.businessResponsible}</td>
      <td className="td">{item.businessInformation.businessName}</td>
      <td className="td">{item.repositoryInformation.description}</td>
    <br></br>
    <td className="td"><a href="#" className="pds-button pds-button-tertiary">
    Ver Detalle</a></td>
      

    </tr>
            </tbody>
             ))}
        </table>
  
  </div>
  
  <div className="pds-dataTable-footer">
    <div className="pds-dataTable-show-entries">
      <label className="pds-dataTable-select-label" />
      <div className="pds-select">
        <select id='' aria-label="Number of rows to display in table" name="entries" className="pds-dataTable-select-options pds-select-small">
          <option value={10} selected>10</option>
          <option value={25}>25</option>
          <option value={50}>50</option>
          <option value={100}>100</option>
        </select>
      </div>
      <p className="pds-dataTable-total-entries" />
    </div>
    <nav aria-label="Pagination" className="pds-pagination pds-dataTable-pagination">
      <span className="pds-dataTable-previous-buttons pds-dataTable-disable-pagination-buttons">
        <a  role="link" tabIndex={0} aria-label="first page" aria-disabled="true" className="pds-dataTable-first-page pds-pagination-fly-first page disabled" />
        <a  role="link" tabIndex={0} aria-label="Previous page" aria-disabled="true" className="pds-dataTable-previous pds-pagination-step-forward page disabled" />
      </span>
      <ul className="pagination" />
      <span className="pds-dataTable-next-buttons">
        <a  role="link" tabIndex={0} aria-label="Next page" className="pds-dataTable-next pds-pagination-step-backward page" />
        <a  role="link" tabIndex={0} aria-label="Last page" className="pds-dataTable-last-page pds-pagination-fly-last page" />
      </span>
    </nav>
  </div>
  
</div>
  
)}



export default ListRepositoryRequest;